'use client';
import React, { useEffect, useState } from 'react';
import { useRouter } from 'next/navigation';
import BootScreen from './boot-screen/page';

export default function RootPage() {
  const router = useRouter();
  const [showBoot, setShowBoot] = useState<boolean | null>(null);

  useEffect(() => {
    const hasBooted = localStorage.getItem('retrodesk-booted');
    if (hasBooted) {
      router?.replace('/desktop-interface');
    } else {
      setShowBoot(true);
    }
  }, [router]);

  if (showBoot === null) return null;

  return <BootScreen />;
}